import { render, staticRenderFns } from "./OrgSubscriptionDetails.vue?vue&type=template&id=6da46ecc&scoped=true"
import script from "./OrgSubscriptionDetails.vue?vue&type=script&lang=js"
export * from "./OrgSubscriptionDetails.vue?vue&type=script&lang=js"
import style0 from "./OrgSubscriptionDetails.vue?vue&type=style&index=0&id=6da46ecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da46ecc",
  null
  
)

export default component.exports